"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { SunIcon, MoonIcon } from "@phosphor-icons/react";

export function ThemeToggle({ className }: {    className?: string }) {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null; // Avoid hydration mismatch

  const isDark = resolvedTheme === "dark";

  return (
    <label className={`relative inline-flex items-center cursor-pointer select-none ${className ?? ""}`}>
      <input
        type="checkbox"
        checked={isDark}
        onChange={() => setTheme(isDark ? "light" : "dark")}
        className="sr-only peer"
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      />
      <div className="w-10 h-6 bg-gray-200 dark:bg-gray-700 rounded-full peer-focus:ring-2 peer-focus:ring-blue-500 transition-colors duration-200 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-500 flex items-center px-1">
        <span className={`transition-transform duration-200 w-4 h-4 rounded-full bg-white shadow-md flex items-center justify-center ${isDark ? 'translate-x-4' : 'translate-x-0'}`}>
          {isDark ? <MoonIcon className="w-3.5 h-3.5 text-blue-600 dark:text-blue-400" /> : <SunIcon className="w-3.5 h-3.5 text-yellow-400" />}
        </span>
      </div>
    </label>
  );
}
